import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CarsysService } from 'src/app/services/http/carsys.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Router } from '@angular/router';
import { UtilMasks } from './../../../utils/util-masks';

@Component({
  selector: 'app-upload-laudo',
  templateUrl: './upload-laudo.component.html',
  styleUrls: ['./upload-laudo.component.scss']
})
export class UploadLaudoComponent implements OnInit {

  masks = {
    mes: {mask: UtilMasks.mes, guide: false},
    ano: {mask: UtilMasks.ano, guide: false},
  };

  form = new FormGroup({
    mes: new FormControl('', [Validators.required, Validators.min(1), Validators.max(12), Validators.maxLength(2), Validators.minLength(2)]),
    ano: new FormControl('', [Validators.required, Validators.min(2000)]),
    arquivo: new FormControl('', [Validators.required])
  });

  constructor(private router: Router, private carsysService: CarsysService, private msgService: ModalMsgService) {
  }

  ngOnInit() {
    this.form.controls.ano.patchValue(new Date().getFullYear());
  }

  setFile() {

  }

  deleteFile() {
    this.form.controls.arquivo.patchValue('');
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.controls.arquivo.setValue(file);
    }
  }

  enviar() {
    if (this.form.invalid) {
      for (const key in this.form.controls) {
        this.form.controls[key].markAsTouched();
      }
      return;
    }
    let form = this.form.value;
    this.carsysService.enviarArquivo(form.mes, form.ano, form.arquivo).then(r => {
      if(!r.success) {
        this.msgService.openDialog('Erro ao enviar arquivo', '', 'danger');
      } else {
        this.router.navigate(['carsys', 'listar']);
      }
    });
  }


}
